import { gql } from '@apollo/client';

export const SCREENER_SESSION = gql`
  query ScreenerSession ($id: ID!){
    screenerSession(id: $id){ 
      tester{
        project{
          disqualifyRedirectUrl
        }
      }
    }
  }
`;
